import { render, staticRenderFns } from "./bBadge.vue?vue&type=template&id=df2890f4&"
import script from "./bBadge.vue?vue&type=script&lang=js&"
export * from "./bBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports